const str = `{HEADER}Privacy Policy

{BODY_TITLE}1. Items of personal information collected and methods of collection
a. Items of personal information collected
First, the company collects the following minimum personal information at the time of initial membership for membership, seamless customer consultation, and the provision of various services.
{ADD_LINE}
Member registration: Name, email address, unidirectional hash encrypted password
When logging in on Facebook: Facebook ID and information provided by Facebook (may include public profile, email address, date of birth, photos and videos)
If you log in to Naver: Information provided by Naver ID and Facebook (you can include public profile, email address, date of birth, photos and videos)
If you log in to Google: Google ID and information provided on Facebook (you can include public profiles, email addresses, date of birth, photos and videos)
{ADD_LINE}
Second, the following information can be generated and collected automatically during service use or business process.
Your IP address, your browser type, your operating system, the link you clicked during your visit to our site, the specific page you see, your location, and your Internet service.
The name of the provider, the webpage you've linked to our site, the date and time of your visit, and the webpage you visit from our site.
{ADD_LINE}
Third, the following information may be collected only by the users of the service in the process of using additional services and custom service or participating in the event.
If consent is obtained for additional collection of personal information
{ADD_LINE}
Fourth, the following payment information can be collected in the process of using paid service.
When credit card payment is made: token
Account transfer: bank name, account number, etc.
Gift Certificate Usage: Gift Certificate Number
{ADD_LINE}
B. How to collect personal information
The company collects personal information in the following ways:
Homepage, written form, fax, telephone, call board, email, event participation, delivery request
Offering from partner companies
Collecting through the Generated Information Collection Tool

{BODY_TITLE}2. Purpose of collecting and using personal information
A. Payment of charges based on the performance of the contract and service provision
Providing content, providing specific custom services, sending goods or bills, authentication, purchase and payment, and collection of charges
I. Member Management
Providing membership services, personal identification, restriction of use of members who violate the bimon terms and conditions, sanctioning acts that interfere with the smooth operation of services and acts that use denial of service, checking their intention to sign up, limiting number of subscription and membership, preserving records for dispute settlement, forwarding notices, and Confirmation of intention to withdrawals
develop new services and use them in marketing and advertising
Developing new services and providing customized services, providing services and publishing advertisements according to statistical characteristics, validating services, providing event information and participation opportunities, providing advertising information, identifying access frequency, and statistics on the use of services by members

{BODY_TITLE}3. Sharing and providing personal information
The company uses the users' personal information within the scope notified in "2. The purpose of collecting and using personal information" and does not use it beyond this scope or disclose the users' personal information outside in principle without the users' prior consent. Exceptions shall be made in the following cases:
A. In case the user agrees with the videomonster interface service in advance
B. In the event that there is a request from the investigative agency in accordance with the provisions of the Act or according to the procedures and methods prescribed in the Act for the purpose of investigation;

{BODY_TITLE}4. Handle personal information
The company consigns personal information as follows to improve the service, and stipulates necessary matters to ensure that the personal information can be safely managed in consignment contracts in accordance with the relevant statutes.
The details of the company's personal information processing agency and consignment work are as follows.
{ADD_LINE}
a trustee company
Contents of consignment work
Personal information retention and period of use
{ADD_LINE}
Google
Analysis of usage data
(Google Analytics) and Data Storage (Google Cloud Platform)
{ADD_LINE}
Microsoft Azure
data storage
(Microsoft Cloud Services)
{ADD_LINE}
MailChimp
Email Communication Support
{ADD_LINE}
Facebook
Personalized Customer Experience Support
{ADD_LINE}
Salesforce
Data storage, customer counseling support
{ADD_LINE}
INICIS
Save payment data
{ADD_LINE}
Zencoder
Convert user-uploaded video files

{BODY_TITLE}5. Personal information retention and period of use
In principle, the user's personal information is destroyed without delay when the personal information collection and utilization purposes are achieved. However, the following information shall be retained for the specified period for the reasons for preservation below:
A. Reason for holding information according to the company's internal policy
Non-conformity use record (abnormal service use record such as fraudulent subscription and disciplinary record)
{ADD_LINE}
Preservation item: subscription authentication mobile phone number
Reason for Conservation: Preventing fraudulent subscription and use
retention period: 2 years
※ 'Protect use record' is a record that has been restricted by the company due to fraudulent subscription and writing posts that violate the operating principles.
{ADD_LINE}
B. Reasons for information retention under relevant laws
When it is necessary to preserve the information according to the provisions of the related statutes, such as the Commercial Act, the Act on Consumer Protection in Electronic Commerce, etc., the company keeps the member information for a certain period of time as specified in the related statutes. In this case, the company uses the information it keeps only for its storage purposes, and the retention period is as follows.
{ADD_LINE}
Records on contracts or withdrawal of subscriptions, etc.
Reason for Conservation: Law on Consumer Protection in Electronic Commerce, etc.
Preservation Period: Five Years
{ADD_LINE}
Records on payment and supply of goods, etc.
Reason for Conservation: Law on Consumer Protection in Electronic Commerce, etc.
Preservation Period: Five Years
{ADD_LINE}
Records on Electronic Financial Transactions
Reason for Preservation: Electronic Financial Transactions Act
Preservation Period: Five Years
{ADD_LINE}
Records of consumer complaints or dispute handling
Reason for Conservation: Law on Consumer Protection in Electronic Commerce, etc.
Retention Period: 3 years
{ADD_LINE}
website visit record
Reasons for Preservation: The Communications Secrets Protection Act
Retention Period: 3 Months

{BODY_TITLE}6. Personal information destruction procedures and methods
In principle, the user's personal information is destroyed without delay when the personal information collection and utilization purposes are achieved.
The procedures and methods for destroying the company's personal information are as follows.
{ADD_LINE}
Destruction procedure.
The information entered by the user for membership registration, etc. is transferred to a separate database after the purpose has been achieved (separate filing case for paper) according to internal policy and other reasons for information protection by related statutes (hold and period of use).
It will be destroyed after a certain period of time has been saved.
This personal information is not used for any other purpose than to be held in accordance with the law.
{ADD_LINE}
How to Destroy
Personal information printed on paper is shredded with a shredder or destroyed through incineration.
Personal information stored in electronic file form is deleted using a technical method that cannot play the recording.

{BODY_TITLE}7. User's rights and their method of exercise
The user can inquire or modify his or her personal information registered at any time. If he or she does not agree to the processing of the company's personal information, he or she can refuse consent or request to sign up (withdrawal of membership). However, in such a case, it may be difficult to use part or all of the service.
{ADD_LINE}
In case there is no member withdrawal menu
You can view the user's personal information by clicking 'Account Settings'. If you want to modify your personal information and sign up (withdrawal of your consent), contact the person in charge of personal information management in writing, by phone, or by email, and we will take care of it without delay.
{ADD_LINE}
In case of membership withdrawal menu
You can view the user's personal information by clicking 'Account Settings'. If you want to modify your personal information, contact the person in charge of personal information management in writing, by phone, or by e-mail, and we will take care of it without delay. In addition, to sign up (withdrawal of consent), you can click "Remove Member" to go through the process of checking yourself before leaving.
{ADD_LINE}
The company processes personal information that has been revoked or deleted at the request of the user as specified in "5. The retention and service period of personal information" and cannot be accessed or used for other purposes.

{BODY_TITLE}8. Items on the installation/operation and refusal of an automatic personal information collection device
What is a cookie?
The company uses 'cookies' to store and retrieve user information from time to time in order to provide personalized and customized services.
The cookie is a very small text file that the server used to run the website sends to the user's browser and is stored on the hard disk of the user's computer. If the user visits the website afterwards, the website server is used to read the contents of cookies stored on the user's hard disk to maintain the user's preferences and provide customized services.
Cookies do not automatically or actively collect information identifying individuals, and users may refuse or delete such cookies at any time.
{ADD_LINE}
I. The purpose of using cookies from the company.
This service is used to identify each service and website visited by the users, the types of visits, security access, and the size of users to provide the users with customized information including advertisements.
다 install/operate and reject cookies
The user has the option of installing cookies. As a result, the user may allow all cookies by setting options in the web browser, check each time the cookies are stored, or refuse to save all cookies.
However, if you refuse to save cookies, you may have difficulty using some of the VCR services that require login.
Here's how to specify whether to allow cookies to be installed (in Internet Explorer):
1 From the Tools menu, choose Internet Options.
2 Click on the Privacy tab.
3 Set the level of personal information processing.

{BODY_TITLE}9. Technical/administrative protection measures for personal information
In handling users' personal information, the company seeks the following technical and administrative measures to ensure safety in order to prevent personal information from being lost, stolen, leaked, tampered with or damaged.
Go. Password encryption
The password of the Videoconster member is encrypted, stored, and managed, so only the principal knows about it, and changes in personal information can be made only by the person who knows the password.
{ADD_LINE}
Countermeasures against hacking, etc.
The company is doing its best to prevent personal information of the members from being leaked or damaged by hacking or computer viruses.
{ADD_LINE}
In case of personal information corruption, we frequently back up data, prevent users' personal information or data from being leaked or damaged by using the latest vaccine program, and secure transmission of personal information on the network through cryptographic communication. We are committed to having all the other technical devices available to ensure security systemically.
{ADD_LINE}
Minimize and train handling personnel
The company's personnel handling personal information are limited to the personnel in charge, and a separate password is assigned for this purpose and updated regularly. Through frequent training for the staff, we always emphasize compliance with the Video Monster Privacy Policy.

{BODY_TITLE}10. Contact information management manager and person in charge
You can report all complaints regarding personal information protection to the personal information management manager or department in charge of the company's service.
The company will promptly provide sufficient answers to the users' reports.
{ADD_LINE}
Personal Information Management Officer
Name: Jeon Dong Hyuk
Member: Information Security Team
Phone: 02-554-6801
Position: Representative Director
Mail: hello@videomonster.co,kr
{ADD_LINE}
Person in charge of personal information management
Name: Song Si-woo
Member: Personal Information Protection Team
Phone: 02-554-6801
Position: Technical Officer
Mail: hello@videomonster.com
{ADD_LINE}
If you need to report or discuss any other personal information violations, please contact the organization below.
Personal Information Violation Reporting Center (privacy.kisa.or.kr / 118 without a National Code
Cyber Crime Division of the Supreme Public Prosecutor's Office (www.spo.go.kr / 1301) without a national number
The National Police Agency's Cybersecurity Bureau (www.ctrc.go.kr / 182)

{BODY_TITLE}11. Other
This is to inform you that this "VideoMonster Privacy Policy" does not apply to websites linked to Videomonster that collect personal information.

{BODY_TITLE}12. Commitment to the High Level
If there is a change or addition, deletion or modification of the current Privacy Policy, the information will be notified on the website at least seven days before the revision. However, if there are any significant changes in user rights, such as the collection and utilization of personal information or the provision of third parties, the user shall be notified at least 30 days in advance.

{FOOTER}
{FOOTER_SUB}These terms and conditions will take effect on May 1, 2019.
`

export default str